import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Text, useCurrentBreakpoint } from '@travel-frontend/core';
import { IconChevronRight } from '@travel-frontend/icons';
import { Container } from '../../components/Banner/components/Container.js';
import { Link } from '../../components/Banner/components/Link.js';
import { Markdown } from '../../components/Banner/components/Markdown.js';
import { MaskedLink } from '../../components/internal/MaskedLink/index.js';
import { NextImage } from '../../components/internal/NextImage/index.js';
import { Flex } from '../../primitives/index.js';
const deviceIdByBreakpoint = {
  xs: 'sm',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'lg'
};
export const Banner = ({
  title: titleProperty,
  subtitle: subtitleProperty,
  link: linkProperty,
  badgeImage: badgeImageProperty,
  backgroundImage: backgroundImageProperty,
  className,
  onClick,
  textColor = 'contentPrimary'
}) => {
  const breakpoint = useCurrentBreakpoint();
  const deviceId = deviceIdByBreakpoint[breakpoint];
  const title = titleProperty?.[deviceId];
  const subtitle = subtitleProperty?.[deviceId];
  const badgeImage = badgeImageProperty?.[deviceId];
  const backgroundImage = backgroundImageProperty?.[deviceId];
  const link = linkProperty?.[deviceId];
  const shouldBeButton = Boolean(onClick && !link?.masked && !link?.href);
  return _jsx(MaskedLink, {
    enabled: link?.masked ?? false,
    href: link?.href,
    target: link?.target,
    rel: link?.rel,
    className: className,
    onClick: onClick,
    children: _jsxs(Container, {
      as: shouldBeButton ? 'button' : 'div',
      onClick: shouldBeButton ? onClick : undefined,
      direction: "row",
      alignItems: "center",
      spacing: "36px",
      backgroundImage: backgroundImage,
      children: [badgeImage && _jsx(NextImage, {
        image: badgeImage.url,
        alt: badgeImage.alt
      }), _jsxs(Flex, {
        alignItems: "flex-start",
        flexGrow: "1",
        spacing: "4px",
        children: [title && _jsx(Text, {
          preset: deviceId === 'sm' ? 'labelXLarge' : 'labelXxLargeBold',
          color: textColor,
          children: _jsx(Markdown, {
            children: title
          })
        }), subtitle && _jsx(Text, {
          preset: "labelLargeSemibold",
          color: textColor,
          children: _jsx(Markdown, {
            children: subtitle
          })
        }), link?.label && _jsxs(Link, {
          children: [link.label, _jsx(IconChevronRight, {})]
        })]
      })]
    })
  });
};